import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { CanvasRenderer } from 'echarts/renderers';
import { LabelLayout } from 'echarts/features';
import { PieChart } from 'echarts/charts';
import { ToolboxComponent, TooltipComponent } from 'echarts/components';
import * as echarts from 'echarts/core';
import { ChartPie } from 'src/app/Interfaces/Admin/charts/SimpleCharPie.interface';
import { ChartPieAngle } from 'src/app/Interfaces/Admin/charts/ChartPieAngle.interface';

@Component({
    selector: 'app-sim-chart-pie-angle',
    templateUrl: './sim-chart-pie-angle.component.html',
    styleUrls: ['./sim-chart-pie-angle.component.scss', '../../../../Components/Styles/GlobalStyles.css'],
    standalone: false
})
export class SimChartPieAngleComponent implements OnInit, OnChanges {

  //+===================== INPUTS =====================+\\
  @Input() DataChartPieAngle!: ChartPieAngle;

  //+================== VARIABLES FOR CHART ==================+\\
  @ViewChild('chartPieAngle', { static: true }) chartContainer!: ElementRef;

  private MyChart!: echarts.ECharts;

  ngOnInit(): void {

    echarts.use([
      ToolboxComponent,
      TooltipComponent,
      PieChart,
      CanvasRenderer,
      LabelLayout
    ]);

    this.MyChart = echarts.init(this.chartContainer.nativeElement);
    this.updateChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['DataChartPieAngle'] && !changes['DataChartPieAngle'].firstChange) {
      this.updateChart();
    }

  }

  private getChartOptions() {

    var option;

    option = {
      title: {
        text: this.DataChartPieAngle.Title,
        left: 'center'
      },
      tooltip: {
        trigger: 'item'
      },
      legend: {
        orient: 'horizontal',
        left: 'center',
        bottom: '0%'
      },

      labelLine: {
        show: true
      },
      emphasis: {
        label: {
          show: true,
          fontSize: 11,
          fontWeight: 'bold'
        }
      },

      color: ['#1CA5D6', '#24BDFF', '#24D5FF', '#24FAFF', '#3CFFFF', '#7BFFFF', '#AEFFFF', '#C8FFFF', '#072834', '#0B3F52', '#0F5A75', '#147496', '#1785AD', '#188FBA', '#1B9DCC', '#1CA5D6', '#21AEEB', '#24BDFF', '#24D5FF', '#24FAFF', '#3CFFFF', '#7BFFFF', '#AEFFFF', '#C8FFFF'],

      series: [
        {
          type: 'pie',
          radius: [`${this.DataChartPieAngle.InnerPercent}%`, `${this.DataChartPieAngle.Percent}%`],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            position: 'none',
            fontSize: 11,
            color: '#fff'
          },
          data: this.DataChartPieAngle.Data.sort(function (a: any, b: any) {
            return a.name - b.name
          })
        }
      ]
    };

    return option
  }

  private updateChart(): void {
    const options = this.getChartOptions();
    this.MyChart.resize();
    this.MyChart.setOption(options);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    if (this.MyChart) {
      this.MyChart.resize();
    }
  }
}
